import { defineStore } from 'pinia'

import api from '@axios'

export const useInsuranceVerificationEntitlementStore = defineStore('vector-insurance-verification-entitlement', {
  actions: {
    async check(providerUuid: string): Promise<boolean> {
      try {
        const { data } = await api.get(`/vector/providers/${providerUuid}/insurance-verification/entitlement`)

        return Boolean(data?.enabled)
      } catch {
        // Fail closed: a network/API error should not silently grant access to the workspace.
        return false
      }
    },
  },
})
